import React from 'react';
import {
  FieldProps,
  ErrorMessage,
} from 'formik';

import {
  Flex,
} from 'web-styled';

import {
  Editor,
} from 'web-components';

import * as S from './styled';

export type Props = {
  color: string,
} & FieldProps;

const EditorField = ({
  field,
  form: {
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
  },
  label,
  color,
  placeholder,
  ...props
}: Props) => {
  const iserror = (touched[field.name] && errors[field.name]);

  return (
    <Flex
      column
      width="100%"
      shrink="0"
      spacing={10}
    >
      {label && (
        <S.Label
          htmlFor={`${field.name}-id`}
          color={color}
        >
          {label}
        </S.Label>
      )}
      <Editor
        {...props}
        iserror={iserror}
        source={field.value}
        placeholder={placeholder}
        onChange={(value) => {
          setFieldValue(field.name, value);
        }}
        onBlur={() => {
          setFieldTouched(field.name);
        }}
      />
      <ErrorMessage
        name={field.name}
        component={S.Error}
      />
    </Flex>
  );
};

EditorField.defaultProps = {
  label: null,
  placeholder: '',
};

export default EditorField;
